import * as _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

/* Load Redux Store */
import { configurationsStoreSelectors } from "../../../../../store/store";
import { levelTextById } from "../../../../Utils/get-sound-level";

import "./SoundsFilterHeader.component.scss";

import { SoundsFilterSelected } from "../SoundsConfigurationSection.component";
import SoundsSearch from "../SoundsSearch/SoundsSearch.component";
import SoundsInformation from "../SoundsInformation/SoundsInformation.component";
import SoundsGroupInformation from "../SoundsGroupInformation/SoundsGroupInformation.component";

export interface SoundsFilterHeaderProps {
    soundGroups: any;
    selectedFilters: SoundsFilterSelected;
    updateFilters: any;
    total: number;
    applyBulkChanges: any;
}

export enum DialogType {
    LEVELS = "levels",
    SUB_LEVELS = "sub_levels"
}

export interface SoundsFilterHeaderState {
    levelsValueToApply: number;
    sublevelsValueToApply: number;
    informationOpen: boolean;
    groupsInfoOpen: boolean;
    applyOpen: boolean;
}

const defaultState = {
    levelsValueToApply: null,
    sublevelsValueToApply: null,
    informationOpen: false,
    groupsInfoOpen: false,
    applyOpen: false
};

class SoundsFilterHeader extends Component<
    SoundsFilterHeaderProps,
    SoundsFilterHeaderState
> {
    groupsSelector: React.RefObject<Components.SelectMenu>;
    levelsSelector: React.RefObject<Components.SelectMenu>;
    subLevelsSelector: React.RefObject<Components.SelectMenu>;
    applyLevelsSelector: React.RefObject<Components.SelectMenu>;
    applySubLevelsSelector: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);

        this.state = defaultState;

        this.groupsSelector = React.createRef();
        this.levelsSelector = React.createRef();
        this.subLevelsSelector = React.createRef();
        this.applyLevelsSelector = React.createRef();
        this.applySubLevelsSelector = React.createRef();
    }

    setGroupFilter = value => {
        this.props.updateFilters({
            ...this.props.selectedFilters,
            selectedGroup: value
        });
    };

    setLevelFilter = value => {
        this.props.updateFilters({
            ...this.props.selectedFilters,
            selectedLevel: value
        });
    };

    toogleInformation = () => {
        this.setState({
            informationOpen: !this.state.informationOpen,
            applyOpen: false,
            groupsInfoOpen: false
        });
    };

    toogleGroupsInformation = () => {
        this.setState({
            groupsInfoOpen: !this.state.groupsInfoOpen,
            applyOpen: false,
            informationOpen: false
        });
    };

    toogleApply = () => {
        this.setState({
            applyOpen: !this.state.applyOpen,
            informationOpen: false,
            groupsInfoOpen: false
        });
    };

    setSubLevelFilter = value => {
        this.props.updateFilters({
            ...this.props.selectedFilters,
            selectedSublevel: value
        });
    };

    setSelectedGames = value => {
        if (!this.props.selectedFilters.selectedGames.includes(value)) {
            this.props.updateFilters({
                ...this.props.selectedFilters,
                selectedGames: [
                    ...this.props.selectedFilters.selectedGames,
                    value
                ]
            });
        }
    };

    removeGameFilter = event => {
        let value = event.target.getAttribute("data-value");
        let selectedGames = this.props.selectedFilters.selectedGames;
        if (selectedGames.includes(value)) {
            let index = selectedGames.indexOf(value);
            if (index > -1) {
                selectedGames.splice(index, 1);
                this.props.updateFilters({
                    ...this.props.selectedFilters,
                    selectedGames: selectedGames
                });
            }
        }
    };

    clearFilters = () => {
        this.groupsSelector.current.selectItem({
            value: -1,
            label: "All Sound Groups"
        });
        this.groupsSelector.current.setDisplayString("All Sound Groups");

        this.levelsSelector.current.selectItem({
            value: -1,
            label: "All"
        });
        this.levelsSelector.current.setDisplayString("All");

        this.subLevelsSelector.current.selectItem({
            value: -1,
            label: "All"
        });
        this.subLevelsSelector.current.setDisplayString("All");

        this.applySubLevelsSelector.current.setDisplayString(
            "Select Sub-Level"
        );

        this.applyLevelsSelector.current.setDisplayString("Select Level");

        this.setState({
            levelsValueToApply: null,
            sublevelsValueToApply: null
        });

        this.props.updateFilters({
            selectedGroup: -1,
            selectedLevel: -1,
            selectedSublevel: -1,
            selectedGames: []
        });
    };

    confirmBulkLevelChange = value => {
        this.setState({
            levelsValueToApply: value
        });
    };

    confirmBulkSubLevelChange = value => {
        this.setState({
            sublevelsValueToApply: value
        });
    };

    bulkEdit = () => {
        this.props.applyBulkChanges(
            this.state.levelsValueToApply,
            this.state.sublevelsValueToApply
        );
    };

    render() {
        let groupsItems = this.props.soundGroups.map(group => {
            return {
                value: group.id,
                label: group.group_description
            };
        });

        groupsItems.unshift({
            value: -1,
            label: "All Sound Groups"
        });

        let levelsAll = [
            {
                value: -1,
                label: "All"
            }
        ];

        const levels = [
            {
                value: 1,
                label: levelTextById(1)
            },
            {
                value: 2,
                label: levelTextById(2)
            },
            {
                value: 3,
                label: levelTextById(3)
            },
            {
                value: 4,
                label: levelTextById(4)
            },
            {
                value: 5,
                label: levelTextById(5)
            }
        ];

        let subLevelsAll = [
            {
                value: -1,
                label: "All"
            }
        ];

        const subLevels = [
            {
                value: 1,
                label: levelTextById(2)
            },
            {
                value: 2,
                label: levelTextById(3)
            },
            {
                value: 3,
                label: levelTextById(4)
            }
        ];

        return (
            <React.Fragment>
                <div id="sounds-filters-header">
                    <div className="filters">
                        <div className="col-3">
                            <label className="label">&nbsp;</label>
                            <SoundsSearch
                                selectedFilters={this.props.selectedFilters}
                                searchAction={this.setSelectedGames}
                            />
                        </div>
                        <div className="col-3">
                            <label className="label">Sound Groups</label>
                            <Components.SelectMenu
                                items={groupsItems}
                                ref={this.groupsSelector}
                                noValueLabel={"Sound Groups"}
                                value={this.props.selectedFilters.selectedGroup}
                                onChange={this.setGroupFilter}
                            />
                        </div>
                        <div className="col-2">
                            <label className="label">Level</label>
                            <Components.SelectMenu
                                items={levelsAll.concat(levels)}
                                ref={this.levelsSelector}
                                noValueLabel={"Levels"}
                                value={this.props.selectedFilters.selectedLevel}
                                onChange={this.setLevelFilter}
                            />
                        </div>
                        <div className="col-2">
                            <label className="label">Sub-level</label>
                            <Components.SelectMenu
                                items={subLevelsAll.concat(subLevels)}
                                ref={this.subLevelsSelector}
                                noValueLabel={"Sub-Levels"}
                                value={
                                    this.props.selectedFilters.selectedSublevel
                                }
                                onChange={this.setSubLevelFilter}
                            />
                        </div>
                        <div className="col-2">
                            <label className="label">&nbsp;</label>
                            <div className="more">
                                <button
                                    className={`filters-more-button ${
                                        this.state.applyOpen ? "open" : ""
                                    }`}
                                    onClick={this.toogleApply}
                                >
                                    More
                                    <i className="icon-ellipsis-v-light"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="row col-12 buttons-info">
                        <div>
                            <button
                                className={`info-button ${
                                    this.state.informationOpen ? "open" : ""
                                }`}
                                onClick={this.toogleInformation}
                            >
                                <i className="icon-exclamation-circle-solid"></i>{" "}
                                Levels Info
                            </button>
                            <button
                                className={`info-button ${
                                    this.state.groupsInfoOpen ? "open" : ""
                                }`}
                                onClick={this.toogleGroupsInformation}
                            >
                                <i className="icon-exclamation-circle-solid"></i>{" "}
                                Groups Info
                            </button>
                        </div>
                        <div className="clear">
                            <button onClick={this.clearFilters}>
                                Clear All
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        <div
                            id="bulkChanges"
                            className={this.state.applyOpen ? `open` : ""}
                        >
                            <div>
                                <div className="row">
                                    <div className="col-5">
                                        <label className="label">
                                            Apply to all Levels column
                                        </label>
                                        <Components.SelectMenu
                                            items={levels}
                                            ref={this.applyLevelsSelector}
                                            noValueLabel={"Select Level"}
                                            onChange={
                                                this.confirmBulkLevelChange
                                            }
                                        />
                                    </div>
                                    <div className="col-5">
                                        <label className="label">
                                            Apply to all Sub-Level column
                                        </label>
                                        <Components.SelectMenu
                                            items={subLevels}
                                            ref={this.applySubLevelsSelector}
                                            noValueLabel={"Select Sub-Level"}
                                            onChange={
                                                this.confirmBulkSubLevelChange
                                            }
                                        />
                                    </div>
                                    <div className="col-2">
                                        <label className="label">&nbsp;</label>
                                        <button
                                            className="red-btn"
                                            onClick={this.bulkEdit}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.props.selectedFilters.selectedGames.length > 0 && (
                        <div className="bullet-filters">
                            {this.props.selectedFilters.selectedGames.map(
                                game => {
                                    return (
                                        <div
                                            className="filter-bullet"
                                            key={`game-${game}`}
                                        >
                                            <p>{game}</p>
                                            <span
                                                data-value={`${game}`}
                                                onClick={this.removeGameFilter}
                                                className="material-icons"
                                            >
                                                clear
                                            </span>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    )}

                    <div className="row">
                        <SoundsGroupInformation
                            open={this.state.groupsInfoOpen}
                        />
                    </div>

                    <div className="row">
                        <SoundsInformation open={this.state.informationOpen} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    soundGroups: configurationsStoreSelectors.soundGroups(state)
});

export default connect(mapStateToProps, {})(SoundsFilterHeader);
